import axios from 'axios'
import { Toast } from 'vant'
import store from '../store/index'
import md5 from 'js-md5'
import { SignatureByRSA } from './crypto'

/* eslint-disable new-cap */
const service = new axios.create({
  timeout: 20000,
  headers: { 'Content-Type': 'application/json' }
})

service.interceptors.request.use(
  config => {
    if (store.getters.lang) {
      config.headers.language = store.getters.lang
    }
    if (store.getters.finalRegionCode) {
      config.headers.region = store.getters.finalRegionCode
    }
    if (store.getters.timezone) {
      config.headers.timezone = store.getters.timezone
    }

    if (config.needSign) {
      config.headers['X-APP-Id'] = 'viomi_oversea_app'
      let timestamp = new Date().getTime()
      config.headers['X-Timestamp'] = timestamp
      let param = JSON.parse(JSON.stringify(config.params || {}))

      let keys = Object.keys(param).sort()
      let queryString = keys.map(key => {
        return key + '=' + param[key]
      }).join('&')
      param['X-Timestamp'] = timestamp
      // 对param的key升序排序，然后根据key的顺序拼接value，用_拼接
      keys = Object.keys(param).sort()
      let queryStringWithTimestamp = keys.map(key => {
        return param[key]
      }).join('_')

      config.headers['X-Nonce'] = md5('~!@#$' + queryStringWithTimestamp + '_thn7$#@!~').substring(0, 12)
      let forSign = timestamp + '\n' + config.headers['X-Nonce'] + '\n' + queryString + '\n'
      config.headers['X-Signature'] = SignatureByRSA(forSign)
    }

    return config
  },
  error => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (
      response.request.responseType === 'blob' // 文件上传，返回文件流
    ) {
      return response
    }
    console.log(response)
    const res = response.data
    if (res.mobBaseRes) {
      res.code = res.mobBaseRes.code
      res.desc = res.mobBaseRes.desc || res.mobBaseRes.error
    }
    if (response.data.code === 0) {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('android') !== -1) {
        window.open(response.request.responseURL)
      } else {
        window.location.href = response.request.responseURL
      }
    }
    if (res.code !== 100 && res.code !== 0) {
      store.commit('updateLoading', false)
      if (res.code === 919 || res.code === 918) {
        // 登陆过期。
        setTimeout(() => {
          Toast(response.data.mobBaseRes.desc)
          window.sessionStorage.token = ''
        }, 3000)
      } else {
        return response.data
      }
    } else {
      return response.data
    }
  },
  error => {
    store.commit('updateLoading', false)
    return Promise.reject(error)
  }
)

export default service
